module.exports = __webpack_public_path__ + "img/y.685df294.png";